export default __webpack_public_path__ + "static/media/0xc56d17dd519e5eb43a19c9759b5d5372115220bd.3b01a967.png";